module.exports = __webpack_public_path__ + "static/media/3.5bf21936.png";